var _path;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
var SvgHeartFilled = function SvgHeartFilled(props) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: "1em",
    height: "1em",
    fill: "none",
    viewBox: "0 0 24 24"
  }, props), _path || (_path = /*#__PURE__*/React.createElement("path", {
    fill: "#000",
    fillRule: "evenodd",
    d: "M6.624 3.02a5.18 5.18 0 0 0-4.078 2.853 4.9 4.9 0 0 0-.528 1.787c-.034.322-.016 1.31.03 1.68.1.782.252 1.442.49 2.124.88 2.517 2.757 4.841 5.86 7.26 1.01.789 2.81 2.051 3.1 2.176.307.132.696.133.999.003.292-.126 2.095-1.39 3.106-2.178 1.389-1.083 2.567-2.182 3.465-3.233 1.676-1.96 2.613-3.96 2.883-6.153.047-.377.065-1.362.032-1.68a5.23 5.23 0 0 0-1.449-3.09 5.17 5.17 0 0 0-2.783-1.493 5.7 5.7 0 0 0-2.027.03c-1.149.24-2.244.894-3.138 1.875-.146.16-.336.385-.42.5-.085.113-.16.207-.166.207s-.062-.07-.124-.155c-.444-.608-1.157-1.279-1.77-1.666a5.4 5.4 0 0 0-2.15-.819 9 9 0 0 0-1.332-.028",
    clipRule: "evenodd"
  })));
};
export default SvgHeartFilled;